import React from 'react';

const AutomationList = ({ automations, loading, selectedId, onSelect, onToggle, emptyStateText }) => {
    return (
        <div className="crm-card crm-card-hover" style={{ height: '100%' }}>
            <div className="crm-card-header">
                <h2 className="crm-card-title">Automations</h2>
            </div>
            <div className="crm-card-body">
                {loading ? (
                    <div className="crm-loading">
                        <div className="crm-spinner" />
                    </div>
                ) : automations.length === 0 ? (
                    <div className="crm-empty-state">
                        <p>{emptyStateText || 'No automations yet.'}</p>
                    </div>
                ) : (
                    <div className="crm-list">
                        {automations.map((automation) => {
                            const isActive = automation.id === selectedId;
                            return (
                                <button
                                    key={automation.id}
                                    type="button"
                                    className="crm-list-row"
                                    onClick={() => onSelect(automation)}
                                    style={{
                                        width: '100%',
                                        textAlign: 'left',
                                        background: isActive ? 'var(--crm-sidebar-hover)' : 'transparent',
                                        border: '1px solid transparent',
                                        padding: '12px',
                                        borderRadius: '12px',
                                        marginBottom: '8px',
                                        color: '#fff',
                                    }}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div>
                                            <div style={{ fontWeight: 600 }}>{automation.name}</div>
                                            <div style={{ fontSize: '12px', color: 'var(--crm-gray-500)' }}>
                                                Trigger: {automation.trigger}
                                            </div>
                                        </div>
                                        <button
                                            type="button"
                                            className={`crm-btn crm-btn-sm ${automation.enabled ? 'crm-btn-success' : 'crm-btn-secondary'}`}
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                onToggle(automation);
                                            }}
                                        >
                                            {automation.enabled ? 'Enabled' : 'Disabled'}
                                        </button>
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AutomationList;
